import React, { Component} from "react";
import * as prosConnect from "../prodect/ProsConnect";
import {ATTR_PICT_ZOOM} from "../prodect/ProsConnect";
import UiImage, {UiImageEditor} from "./UiImage";

// Disable log for release builds
const IMG_ID_PREFIX = 'pzp-img__';
export const NO_ZOOM = {scale: 1, positionX: 0, positionY: 0}
export const PROS_ZOOM_MAX_SCALE = 8

class ImageWithMarker extends Component{
    constructor(props) {
        super(props);
        this.state = {
            editMode: props.initialEditMode,
            marker: prosConnect.getPictureMarkerLocationInfo(this.props.item),
            hasMarker: prosConnect.pictureHasMarker(this.props.item),
            zoomCenter: NO_ZOOM,
            imgDim: undefined,
        }
    }

    // Marker save button clicked
    saveButtonClicked(zoomCenter) {
        prosConnect.prosLog("set picture marker and zoom", this.state.marker, zoomCenter);
        prosConnect.setPictureMarkerLocation(this.props.item, this.state.marker);
        if (this.state.imgDim && this.state.imgDim.viewW && this.state.imgDim.imgH) {
            function scale(tl, viewDim) {
                return (Math.abs(tl) + viewDim/2) / (viewDim * zoomCenter.scale)
            }
            const zoomInfo = {
                scale: zoomCenter.scale,
                cx: scale(zoomCenter.positionX, this.state.imgDim.viewW),
                cy: scale(zoomCenter.positionY, this.state.imgDim.viewH),
                imgW: this.state.imgDim.imgW,
                imgH: this.state.imgDim.imgH,
                viewW: this.state.imgDim.viewW,
                viewH: this.state.imgDim.viewH
            }
            this.props.item[ATTR_PICT_ZOOM] = prosConnect.encodePictZoomInfo(zoomInfo)
        }
        if (this.props.updateItem) {
            this.props.updateItem(this.props.item);
        }
        this.setState({
            editMode: false
        })
        this.onImageMinimizeClicked()
    }

    onImageMinimizeClicked(){
        if (this.props.minimizePicture) {
            this.props.minimizePicture()
        }
    }

    absoluteToRelativeCoords(img, x, y) {
      //const logValues = true;

      const factorX = img.naturalWidth / img.width;
      const factorY = img.naturalHeight / img.height;

      let realX = x * factorX;
      let realY = y * factorY;

      let relativeX = realX / img.naturalWidth;
      let relativeY = realY / img.naturalHeight;

      return{
        x: relativeX,
        y: relativeY
      };
    }

    relativeToContainerCoords(img, x, y){
      return {
        x: x * img.width,
        y: y * img.height
      }
    }

    resetMarkerAndZoom() {
        /* Get marker location information */
        this.setState({marker: prosConnect.getPictureMarkerLocationInfo(this.props.item)})
    }

    calcZoomCenter(imgDim) {
        this.setState({imgDim: imgDim})
        const itemZoomInfo = prosConnect.getPictureZoomInfo(this.props.item)
        if (!itemZoomInfo) {
            return
        }
        if (itemZoomInfo.imgW !== imgDim.imgW || itemZoomInfo.imgH !== imgDim.imgH) {
            prosConnect.prosLogWrn("IMG", this.props.item.obj_id, "size mismatch itemZoomInfo:", itemZoomInfo, ", browser imgDim:", imgDim)
        }
        // Compute offset as image is aligned to top left corner
        // limit offset when center is close to edge so that to show image in full view
        let scale = Math.min(Math.max(itemZoomInfo.scale, 1), PROS_ZOOM_MAX_SCALE)
        function calcOffset(center, imgSize) {
            let relativeOffset = center * scale
            if (relativeOffset < 0.5) {
                relativeOffset = 0.5
            } else if (relativeOffset > scale - 0.5) {
                relativeOffset = scale - 0.5
            }
            return (0.5-relativeOffset) * imgSize
        }
        let zoom = {
            scale: scale,
            positionX: calcOffset(itemZoomInfo.cx, imgDim.viewW),
            positionY: calcOffset(itemZoomInfo.cy, imgDim.viewH),
        }
        this.setState({zoomCenter: zoom})
    }

    handleClickImg = (e) => {
        let image = e.target
        /// Convert to relative coordinates
        const relative = this.absoluteToRelativeCoords(image, e.nativeEvent.offsetX, e.nativeEvent.offsetY)
        const marker = {
          inUse: true,
          x: relative.x,
          y: relative.y,
        }
        if (this.props.listenMarkerChanges) {
            this.props.listenMarkerChanges(marker)
        }
        this.setState({
            marker: marker
        })
    }

    pictureClicked =(e, isPlacingMarker, hasEditedPicture)=> {
          if(isPlacingMarker){
              /* Change event target to img. This is to trick image click handler to think that image was clicked */
              e.target = document.getElementById(IMG_ID_PREFIX + this.props.item.obj_id)
              this.handleClickImg(e)
          } else if (!hasEditedPicture) {
              // Close big image when click and not placing marker and have not changed zoom
              this.onImageMinimizeClicked()
          }
    }

    toggleShowMarker() {
        let newMarker = prosConnect.deepCopyObj(this.state.marker)
        newMarker.inUse = !this.state.marker.inUse
        this.setState({
            marker: newMarker
        })
    }

    render(){
        let imagePath = prosConnect.getItemImagePath(this.props.item)
        return <UiImageEditor
                imageEditControls={this.props.imageEditControls}
                isMarkerPlacingEnabled={this.state.editMode}
                marker={this.state.marker}
                zoomCenter={this.state.zoomCenter}
                imgDim={this.state.imgDim}
                initialMarker={this.props.initialMarker || prosConnect.getPictureMarkerLocationInfo(this.props.item)}
                toggleShowMarker={() => this.toggleShowMarker()}
                pictureClicked={(e, isPlacingMarker, hasChangedZoom)=> this.pictureClicked(e, isPlacingMarker, hasChangedZoom)}
                minimizePicture={this.props.minimizePicture}
                onSave={(zoomCenter) => {
                    this.saveButtonClicked(zoomCenter)
                    if (this.props.onSave) this.props.onSave()
                }}
                onCancel={()=> {
                    if (this.props.onCancel) {
                        this.props.onCancel()
                    } else {
                        this.resetMarkerAndZoom()
                    }
                }}
            >
            <UiImage
                imageId={IMG_ID_PREFIX + this.props.item.obj_id}
                imageSrc={imagePath}
                showFullImage={true}
                item={this.props.item}
                marker={this.state.marker}
                onImageLoad={(imgDim) => {
                    this.calcZoomCenter(imgDim)
                }}
            />
        </UiImageEditor>
    }
}
export default ImageWithMarker
